/*
 * Copyright (c) Siemens AG 2018 ALL RIGHTS RESERVED.
 *
 * Digital Lifecycle Service (DLS)
 */

import React from 'react';
import axios from 'axios';
import $ from 'jquery';

import NavigationBarComponent from './NavigationBarComponent';
import ContentComponent from './ContentComponent';
import NavigationBarElementComponent from './NavigationBarElementComponent';
import classes from './AdminPage.module.css';
import { MENU_SHORT_DESCRIPTION } from '../../../store/adminPageDescriptionConfig';

export default class AdminPageComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      template: {
        __html: ''
      },
      sideBarOpen: true,
      clickedUsecase: '',
      selectedUrl: '',
      getDetailsApiLoading: true,
      menuDescription: '',
      newArch: false,
      component: ''
    };
  }

  componentDidMount() {
    this.props.setCurrentRouteState('ap', 'Admin Page');
    //for having nav menu compressed by default
    $('.accordion-content').toggle();
    // to load the html angluar div for running angluar pages
    $('.' + classes.AdminPage).load('/html/angularContainer.html');
  }
  // componentDidUpdate() {
  //   // to load the html angluar div for running angluar pages
  //   $('.' + classes.AdminPage).load('/html/angularContainer.html');
  // }

  getEmailFromToken(token) {
    let email = '';
    if (token) {
      let base64Url = token.split('.')[1];
      if (base64Url) {
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        let parsedSecurityToken = JSON.parse(window.atob(base64));
        if (parsedSecurityToken && parsedSecurityToken.sub) {
          email = parsedSecurityToken['http://cep.com/email'];
          if (email== null && parsedSecurityToken!= null)	{
					  email = parsedSecurityToken['email'];
				  }

        }
      }
    }
    return email;
  }

  /**
   * Handler for selected usecase
   * Loads the given url of the usecase and updates state
   * @param servicePath
   * @param usecasePath
   * @param usecaseComponent
   */
  onAccordionSelect(servicePath, usecasePath, usecaseComponent) {
    const selectedPath = `${servicePath}${usecasePath}`;
    const isAlarmOverview =
      selectedPath === 'scdp/sh.static/html/sh_alarmOverview.html';

    if (usecaseComponent) {
      this.setState({
        component: usecaseComponent
      })
      return;
    }
    // if (usecasePath == 'hl/hl.static/html/hl_emailConfig.html') {
    //   console.log('new arch-.');
    //   // new arch
    //   this.setState({
    //     selectedUrl: `${servicePath}${usecasePath}`,
    //     clickedUsecase: `${usecasePath}`,
    //     newArch: true
    //   });
    // } else {
    // old arch
    const url = `${this.props.settings.server}${servicePath}${usecasePath}`;
    let menuDesc = MENU_SHORT_DESCRIPTION.find(
      (m) => m.name === `${servicePath}${usecasePath}`
    );

    if (isAlarmOverview) {
      this.setState({
        clickedUsecase: `${usecasePath}`,
        oldCase: false,
        menuDesc: null,
        selectedUrl: selectedPath,
        component: '',
        template: {
          __html: ''
        }
      });
      return;
    }

    if (usecasePath !== this.state.clickedUsecase) {
      this.setState(
        {
          clickedUsecase: `${usecasePath}`,
          oldCase: false,
          menuDesc: menuDesc ? menuDesc.description : null,
          component: ''
        },
        () => {
          // Load template from backend and show inside ContentComponent
          this.getServiceTemplate(url)
            .then(({ data }) => {
              if (!this.state.oldCase) {
                this.setState({
                  template: {
                    __html: data
                  },
                  selectedUrl: `${servicePath}${usecasePath}`,
                  clickedUsecase: `${usecasePath}`
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      );
    } else {
      this.setState({
        oldCase: true,
        menuDesc: menuDesc ? menuDesc.description : null
      });
    }
    // }
  }
  togglehere() {
    this.setState({
      template: {
        __html: "<div class='dls-lp-loader'></div>"
      }
    });
    this.setState((prevState) => {
      return { sideBarOpen: !prevState.sideBarOpen };
    });
  }

  render() {
    // iterate through the whole groups array and create navigation bar content
    let accordions =
      this.props.groups &&
      this.props.groups.map((group) => {
        let services =
          group.services &&
          group.services.map((service) => {
            let usecases =
              service.usecases &&
              service.usecases.map((usecase) => {
                // create usecases for accordions
                return (
                  <NavigationBarElementComponent
                    key={usecase.path}
                    toggle={() => {
                      this.togglehere();
                    }}
                    sideBarOpen={this.state.sideBarOpen}
                    clickedUsecase={this.state.clickedUsecase}
                    isActive={
                      this.state.selectedUrl ===
                      `${service.path}${usecase.path}`
                    }
                    usecaseName={usecase.name}
                    usecasePath={usecase.path}
                    usecaseComponent={usecase.component}
                    onAccordionSelect={(usecasePath) =>
                      this.onAccordionSelect(service.path, usecasePath, usecase.component)
                    }
                  />
                );
              });

            // create accordions for navigation bar
            return (
              <div className="accordion" key={service.name}>
                <h2 className="application-header-ah3 closed dls-ap-accordion-header">
                  {service.name}
                </h2>
                <div
                  className="accordion-content"
                  style={{ display: 'block' }}
                  id={service.service}
                >
                  {usecases}
                </div>
              </div>
            );
          });

        // create navigation bar content
        return (
          <div key={services}>
            <h2 className="dls-ap-margin-bottom">{group.groupTitle}</h2>
            {services}
          </div>
        );
      });
    let wrapperClass;
    if (this.state.sideBarOpen) {
      wrapperClass = 'dls-ap-wrapper';
    } else {
      wrapperClass = 'dls-ap-wrapper close';
    }
    //To check wether the usecase is selected or not
    if (!this.state.oldCase) {
      return (
        <React.Fragment>
          <div className={wrapperClass}>
            <NavigationBarComponent sideBar={this.state.sideBarOpen}>
              {accordions}
            </NavigationBarComponent>

            <ContentComponent
              menuDesc={this.state.menuDesc}
              content={this.state.template}
              newArch={this.state.newArch}
              selectedUrl={this.state.selectedUrl}
              component={this.state.component}
              settings={this.props?.settings}
              ppid={this.props.ppid}
              showNewAppBanner={this.state.selectedUrl === 'scdp/sh.static/html/sh_alarmOverview.html'}
            />

            <div className="dls-ap-cleared"></div>
            <div className={classes.AdminPage}></div>
          </div>
        </React.Fragment>
      );
    } else {
      //return the div without content div of service
      return (
        <React.Fragment>
          <div className={wrapperClass}>
            <NavigationBarComponent sideBar={this.state.sideBarOpen}>
              {accordions}
            </NavigationBarComponent>
            <div className="dls-ap-cleared"></div>
          </div>
          <div className={classes.AdminPage}></div>
        </React.Fragment>
      );
    }

    // render end
  }

  /**
   * Returns promise for requested url
   * @param url
   * @returns {AxiosPromise}
   */
  getServiceTemplate(url) {
    return axios({
      method: 'get',
      url: url
    });
  }

  /**
   * Returns the boolean flag for is_rec by parsing token.
   */
  getIsRecFlag(token) {
    let flag = false;
    if (token) {
      let base64Url = token.split('.')[1];
      if (base64Url) {
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        let parsedSecurityToken = JSON.parse(window.atob(base64));
        flag = parsedSecurityToken.is_rec;
      }
    }
    return flag;
  }
}
